import Layout from './Layout';
import MainLayout from './MainLayout';
export { MainLayout };
// 默认导出Layout，用于兼容之前开发的组件
export default Layout;
